import * as Types from 'src/actions/juridical-person/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import { Validation } from 'src/services/validation/Validator';
import JuridicalPerson from 'src/entities/JuridicalPerson';

export interface CreateJuridicalPersonAttempt extends Action {
  type: Types.CREATE_JURIDICAL_PERSON_ATTEMPT;
}

export interface CreateJuridicalPersonSuccess extends Action {
  type: Types.CREATE_JURIDICAL_PERSON_SUCCESS;
}

export interface CreateJuridicalPersonFailure extends Action {
  type: Types.CREATE_JURIDICAL_PERSON_FAILURE;
  payload: {};
}

export type CreateJuridicalPersonAction =
  CreateJuridicalPersonAttempt |
  CreateJuridicalPersonSuccess |
  CreateJuridicalPersonFailure;

export interface CreateJuridicalPersonThunk extends ThunkAction<Promise<CreateJuridicalPersonAction>, RootState, null> {
}

export const createJuridicalPersonAttempt: ActionCreator<CreateJuridicalPersonAttempt> = () => (
  { type: Types.CREATE_JURIDICAL_PERSON_ATTEMPT }
);

export const createJuridicalPersonSuccess: ActionCreator<CreateJuridicalPersonSuccess> = () => (
  {
    type: Types.CREATE_JURIDICAL_PERSON_SUCCESS,
  }
);

export const createJuridicalPersonFailure: ActionCreator<CreateJuridicalPersonFailure> = (error: {}) => (
  {
    type: Types.CREATE_JURIDICAL_PERSON_FAILURE,
    payload: error
  }
);

export const createJuridicalPerson: ActionCreator<CreateJuridicalPersonThunk> = (
  person: JuridicalPerson
): CreateJuridicalPersonThunk => {

  return (dispatch: Dispatch<RootState>): Promise<CreateJuridicalPersonAction> => {

    dispatch(createJuridicalPersonAttempt());

    let restrictions: Validation[] = [
      { value: person.name, message: 'name' },
      { value: person.surname, message: 'surname' },
      { value: person.enterpriseName, message: 'enterpriseName' },
    ];

    const validation = ValidatorService.validate(restrictions);

    return validation.then(() => {

      return ApiClient.juridicalPerson.create(person)
        .then((response: AxiosResponse): CreateJuridicalPersonSuccess => {
          return dispatch(createJuridicalPersonSuccess());
        }).catch((e: { response: { data: { errors: {} , error: string } } }): CreateJuridicalPersonFailure => {
          const errors: {} | string = e && e.response && e.response.data && 
          ( e.response.data.errors || e.response.data.error );
          const errorMessages = ValidatorService.translateValidations(errors);

          return dispatch(createJuridicalPersonFailure(errorMessages));
        });
    }).catch((errors) => {
      return dispatch(createJuridicalPersonFailure(errors));
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/juridical-person/create/CreateJuridicalPerson.actions.tsx